import { render, staticRenderFns } from "./business_field_management.vue?vue&type=template&id=7074caff&scoped=true"
import script from "./business_field_management.vue?vue&type=script&lang=js"
export * from "./business_field_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7074caff",
  null
  
)

export default component.exports